import { billingCycleOptions, billingCycleType } from '@selfserve/react-utils';

import { currencyOptions } from './currency-options';
import { packageStatusOptions } from './package-status-options';

export const schema = {
  name: { type: 'string', title: 'Name' },
  description: { type: 'string', title: 'Description' },
  status: { type: 'select', title: 'Status', options: packageStatusOptions },
  product: { type: 'string', title: 'Product' },
  product_family: { type: 'string', title: 'Product family' },
  kaltura_analytic_ref: { type: 'string', title: 'Kaltura analytic ref' },
  remote_ref_id: { type: 'string', title: 'Remote ref id' },
  remote_ref_system_id: { type: 'string', title: 'Remote ref system id', showDivider: true },
  license_items: {
    type: 'array',
    title: 'License Items',
    showDivider: true,
    item: {
      type: 'object',
      direction: 'row',
      properties: {
        name: { type: 'string', title: 'Name' },
        value: { type: 'string', title: 'Value' },
      }
    }
  },
  pricing_info: {
    type: 'array',
    title: 'Pricing info',
    item: {
      type: 'object',
      direction: 'row',
      template: {
        id: '',
        description: '',
        billing_cycle: billingCycleType.YEAR,
        currency: '',
        price: 0,
      },
      properties: {
        id: { type: 'string', title: 'ID' },
        description: { type: 'string', title: 'Description' },
        billing_cycle: { type: 'select', title: 'Billing cycle', options: billingCycleOptions },
        currency: { type: 'select', title: 'Currency', options: currencyOptions },
        price: { type: 'number', title: 'Price' },
      }
    }
  }
};
